import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  Box,
  Typography,
} from "@mui/material";
// import { editRule } from "../../../api's/DataModelApi"; // <-- Your API

const EditRuleModal = ({ open, onClose, rule, attributes, entityId, onUpdate }) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (rule) {
      const arr = rule.appliesTo ? rule.appliesTo.split(",").map(s => s.trim()) : [];
      setSelected(arr);
    }
  }, [rule]);

  const toggleChip = (attr) => {
    setSelected((prev) =>
      prev.includes(attr)
        ? prev.filter((a) => a !== attr)
        : [...prev, attr]
    );
  };

  const handleUpdate = async () => {
    const payload = {
      entityId,
      ruleName: rule.rule_name,
      appliesTo: selected,
    };
    console.log("payload for edit : ", payload);

    try {
    //   await editRule(payload);
      onUpdate();
      onClose();
    } catch (err) {
      console.error("Failed to update:", err);
    }
  };

  if (!rule) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <strong>{rule.rule_name}</strong>
      </DialogTitle>

      <DialogContent dividers>
        <Typography mb={1}>Select attributes to apply this rule:</Typography>

        <Box
          sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}
        >
          {attributes?.map((attr) => (
            <Chip
              key={attr.attribute_id}
              label={attr.name}
              clickable
              onClick={() => toggleChip(attr.name)}
              color={selected.includes(attr.name) ? "primary" : "default"}
              variant={selected.includes(attr.name) ? "filled" : "outlined"}
            />
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">Cancel</Button>
          <Button
    onClick={handleUpdate}
    variant="contained"
    disabled={!selected || selected.length === 0}
  >
    Update
  </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditRuleModal;
